export default __webpack_public_path__ + "static/media/anthe-results-desktop-banner.4b6e13c2.webp";